import iconUpload from "../images/uploadArrow.png";
import HapoalimIcon from "../images/icons/icon4.png";

import hapoalimConnect from "./HapolaimImages/1_step_1.png";
import hapoalimSetupBankPermission from "./HapolaimImages/1_step_4.png";
import hapoalimConfirmBankPermission from "./HapolaimImages/hapoalimConfirm.png";
import hapoalimPrintBankPermission from "./HapolaimImages/1_step_6.png";
import logotype_finalStep from "./finalStepImages/logotype_finalStep.png";

const hapoalimBank = {
  id: "1",
  logo: HapoalimIcon,
  name: "Bank Hapoalim",
  steps: [
    {
      he: {
        title: `
                    <h2>
                      התחברות לחשבון הבנק
                    </h2>
                    `,
        content: `
                    <p>
                     הכניסו את הפרטים
                      <br /> (פרטי ההתחברות אינם גלויים לנו)
                    </p>
                    `,
        stepScreen: hapoalimConnect,
      },
    },
    {
      he: {
        title: `
                    <h2>
                      פנה/י לאישור הקמת הרשאה
                      <br /> ומלא/י פרטים
                    </h2>
                    `,
        content: `
                        <p>
                            לחץ/י על ״עובר ושב״
                          <br /> לאחר מכן ״הרשאות והוראות קבע״
                          <br /> ולאחר מכן ״הקמת הרשאה לחיוב חשבון״
                          <br />
                          <br/>  הכנס/י קוד מוסד 27662  
                          <br/> שים לב, שם המוסד הוא פיטופי שהוא שם החברה 
                          
                          <br />
                          <br/> עבור מספר לקוח, כדי שנוכל לזהות אתכם
                          <br/> אנא מלא/י את מספר הטלפון שאיתו נרשמתם לבלינק/פיטופי 
                        </p>
                `,
        stepScreen: hapoalimSetupBankPermission,
      },
    },
    {
      he: {
        title: `
                    <h2>
                      אשר/י את הקמת ההרשאה
                    </h2>
                    `,
        content: `
                        <p>
                         עבור/עברי על הפרטים
                         <br /> סמן/י את ״אני מסכים לתנאי הבקשה״
                         <br /> ולחץ/י על ״אישור״
                          
                        </p>
                `,
        stepScreen: hapoalimConfirmBankPermission,
      },
    },
    {
      he: {
        title: `
                    <h2>
                      שלח/י לנו את האישור
                    </h2>
                    `,
        content: `
                        <p>
                            שמור/שמרי את האישור בקובץ fdp
                          <br /> ע״י לחיצה על אייקון ה- fdp ושמירה כקובץ
                          
                        </p>
                `,
        button: {
          btnIcon: iconUpload,
          downloadTitle: `
                      <h3>העלאת קובץ אישור הקמת הרשאה</h3>
                      `,
        },
        stepScreen: hapoalimPrintBankPermission,
        hideNextButton: true
      },
    },
    {
      he: {
        title: `
                    <h2>
                      כל הכבוד!
                    </h2>
                    `,
        content: `
                    <p>
                      קיבלנו את הקובץ ונקים עבורך את ההרשאה תוך שני ימי עסקים 
                    </p>
                    `,
          finalStep: {
              logotype: logotype_finalStep,
              title_logotype: `
                       <h4>כל הכבוד!</h4>
                       `,
          },
      },
    },
  ],
};

export default hapoalimBank;
